@if (isReadonlyWrapper$ | async; as isReadonlyWrapper) {
  <div>
    <div class="flex align-items-center justify-content-between">
      <div class="w-8">
        <p class="title3Font mt-0"
           i18n>Keywords</p>
        @if (subHeader) {
          <p class="body2Font">{{ subHeader }}</p>
        }
      </div>
      @if (!isReadonlyWrapper.isReadonly) {
        <div class="flex align-items-center">
          <i class="fas fa-info-circle"></i><span class="subtitle3Font ml-2 mr-5"
                i18n>How to type keywords correctly?</span>
          <p-button (onClick)="write()"
                    label="Write keywords"
                    i18n-label
                    styleClass="p-button-outlined">
          </p-button>
        </div>
      }
    </div>
    @if (!isReadonlyWrapper.isReadonly) {
      <et-header-autocomplete [queryExpression]="data.lookupKeywords"
                              [addAction]="data.addAction"
                              (itemsAdded)="onKeywordCountChanged()"
                              placeholder="Search keyword(s)"
                              i18n-placeholder>
      </et-header-autocomplete>
    }
    <div>
      @if (tableSettings) {
        <p-table [scTableSettings]="tableSettings">
          @if (!isReadonlyWrapper.isReadonly; as rowData) {
            <ng-template pTemplate="row-actions"
                         let-rowData>
              <p-button styleClass="p-button-rounded p-button-text"
                        icon="fas fa-trash"
                        (onClick)="onRemoveKeyword(rowData.id)"
                        pTooltip="Click to remove keyword"
                        tooltipPosition="top"
                        i18n-pTooltip>
              </p-button>
            </ng-template>
          }
        </p-table>
      }
    </div>
  </div>
}